export default [
    {
        key: "forwardhead",
        name: "सिर आगे झुका हुआ",
        definition: {
            name: "परिभाषा",
            list: ["सिर आगे झुका हुआ इसका मतलब है कि जब मानव शरीर स्‍थिर खड़े या बैठे हुए स्‍थिति में होता है, तो सिर शरीर के क्षेत्र के सामने असामान्‍य रूप से झुका हुआ होता है। यह लंबे समय तक बैठे हुए छात्रों और कार्यालय के लोगों में आम है।"]
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. लंबे समय तक झुके हुए काम करना। जब कोई लंबे समय तक कंप्यूटर के सामने काम करता है, तो सिर आमतौर पर आगे झुकता है।",
                "2. मोबाइल को देखने के लिए सिर झुकाने की आदत. सिर झुकाकर मोबाइल देखना, यानी जिसे ‘सिर झुकाने वाले कबीले’ कहा जाता है, यह भी सिर आगे झुकने का एक प्रमुख प्रेरक कारण है।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. चक्कर और सिर दर्द: सिर आगे झुकना सिर के रक्त प्रवाह को प्रभावित कर सकता है। खराब रक्त प्रवाह के कारण सिर में ऑक्सीजन की कमी हो सकती है, जो चक्कर और सिर दर्द का कारण बनता है।",
                "2. गर्दन के दर्द: सिर के असामान्‍य स्‍थिति के कारण गर्दन के मुलायम ऊतकों और हड्डियों में विषमताएं होती हैं, जिससे गर्दन के रोगों के खतरे बढ़ जाता है।",
                "3. हृदय और सिर के रक्त वाहिका रोग: सिर के असामान्‍य स्‍थिति से सिर के रक्त प्रवाह को प्रभावित हो सकता है और हृदय और सिर के रक्त वाहिका के स्वास्थ्य को हानि पहुंचा सकता है।",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "सिर का पार्श्व झुकाव",
        definition: {
            name: "परिभाषा",
            list: ["सिर का पार्श्व झुकाव इसका मतलब है कि जब मानव शरीर स्‍थिर खड़े या बैठे हुए स्‍थिति में होता है, तो सिर एक ओर की ओर अत्यधिक झुका हुआ है। मुख्य कारण दोनों ओर कंधे और गर्दन की मांसपेशियों की शक्ति का असंतुलन है, जो आमतौर पर आदतन गलत स्‍थितियों के कारण होता है।"]
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. एक तरफ के गर्दन और कंधे के मांसपेशियों का प्रयोग करने की आदत: बैठने या लेटने के समय, गर्दन अक्सर केवल एक तरफ मुड़ती है, जिससे दोनों ओर के कंधे और गर्दन के मांसपेशियों की शक्ति में असंतुलन होता है।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. मांसपेशियों और बंधुओं का क्रोनिक खराब होना: लंबे समय तक सिर का पार्श्व झुकाव गर्दन के पीछे के बंधुओं और मांसपेशियों के बंधुओं के कारण क्रोनिक खराब हो सकता है।",
                "2. गर्दन के दर्द: सिर के असामान्‍य स्‍थिति के कारण गर्दन के मुलायम ऊतकों और हड्डियों में विषमताएं होती हैं, जिससे गर्दन के रोगों के खतरे बढ़ जाता है।",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "असमान कंधे",
        definition: {
            name: "परिभाषा",
            list: ["असमान कंधे इसका मतलब है कि जब मानव शरीर स्‍थिर खड़े या बैठे हुए स्‍थिति में होता है, तो कंधे एक ओर की ओर अत्यधिक झुका हुआ है। मुख्य कारण दोनों ओर कंधे और गर्दन की मांसपेशियों की शक्ति का असंतुलन है, जो आमतौर पर आदतन गलत स्‍थितियों के कारण होता है।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. एक तरफ के अतिरिक्त बोझ: उदाहरण के लिए, लंबे समय तक एक तरफ से बैग या भारी वस्तुएं ले जाना।",
                "2. लंबे समय तक गलत बैठने की मुद्रा: बुरी आदतों के कारण, जैसे लंबे समय तक पैरों को क्रॉस करके बैठना, डेस्क पर काम करते समय डेस्क पर झुकना आदि।"
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. कमर का दर्द: (असमान कंधे) पेल्विस के विस्थापन का कारण बन सकते हैं, जिससे कमर के दोनों ओर की मांसपेशियों की शक्ति असंतुलित हो जाती है और कमर का दर्द हो जाता है।",
                "2. हड्डी के टुकड़े: असमान कंधे से गर्दन के हड्डे पर असामान्य बल लगता है, और अंत में गर्दन के हड्डे के क्षेत्र में क्षरण हो सकता है और हड्डी के टुकड़े बन सकते हैं।",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "गोल कंधे",
        definition: {
            name: "परिभाषा",
            list: ["गोल कंधे का मतलब है कि जब शरीर को पार्श्व से देखा जाता है तो कंधे आगे और अंदर की ओर मुड़े हुए दिखाई देते हैं। अधिकतर कुहरे के साथ होता है। छात्रों और कार्यालय में काम करने वालों में आम है।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. आदतन ख़राब मुद्रा: जैसे कि छाती के बल झुकना, अनियमित रूप से एक तरफ लेटना, एक तरफ करवट लेकर लेटना आदि।",
                "2. छाती और पीठ के मांसपेशियों में असंतुलन: स्तन मांसपेशियाँ पीठ के मांसपेशियों की तुलना में अपेक्षाकृत कमजोर हैं।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. हृदय के लिए बढ़ी बोझ: अत्यधिक गोल कंधे से डायाफ्राम तनाव में आ जाएगा, जिससे बड़ी धमनी और कैवा वेन को दबाव होगा और हृदय के काम का बोझ बढ़ेगा।",
                "2. तंत्रियों को दबाना: कंधे और गर्दन के आसपास की मांसपेशियों का तनाव, गंभीर स्थिति में गर्दन के तंत्रियों को दबा सकता है, जिससे सिरदर्द और बांह में सुन्न होने लगता है।",
            ],
        }
    },
    {
        name: "कशेरुका का पार्श्व झुकाव",
        key: "scoliosis",
        definition: {
            name: "परिभाषा",
            list: ["यदि रीढ़ की हड्डी की स्थिति में कोई असामान्यता है, तो इमेजिंग जांच से स्कोलियोसिस जैसी रीढ़ की हड्डी में गैर-संरेखण का पता चल सकता है। असामान्यताओं को जन्मजात और अधिग्रहित में विभाजित किया जा सकता है। अर्जित असामान्यताएं आदतन मुद्रा त्रुटियों से संबंधित हैं।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. एक तरफ के लिए अत्यधिक बोझ: उदाहरण के लिए, लंबे समय तक एक तरफ से बैग या भारी वस्तुएं उठाना।",
                "2. लंबे समय तक गलत बैठने की मुद्रा: बुरी आदतों के कारण, जैसे लंबे समय तक पैरों को क्रॉस करके बैठना, डेस्क पर काम करते समय डेस्क पर झुकना आदि।",
                "3. जन्मजात कारण: जन्मजात कारणों से होने वाला कशेरुका का पार्श्व झुकाव।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. कशेरुका के लम्बे खंड में डिस्क प्रोट्रूजन।",
                "2. कशेरुका का दर्द: हिप के विस्थापन को पैदा कर सकता है, जिससे कमर के दोनों तरफ की मांसपेशियों की शक्ति असंतुलित हो जाती है और कशेरुका का दर्द हो जाता है।",
                "3. अलग-अलग लंबाई की टाँगें।",
            ],
        }
    },
    {
        name: "पेल्विस का पार्श्वीय झुकाव",
        key: "unevenhip",
        definition: {
            name: "परिभाषा",
            list: ["पेल्विस का पार्श्वीय झुकाव का मतलब है कि दोनों तरफ के हिप की ऊंचाई काफी भिन्न है, जिससे पेल्विस का झुका हुआ स्थिति प्रकट होती है। अधिकतर कशेरुका के स्थिति में विषमता और असमान कंधे के साथ होता है।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. लंबे समय तक गलत बैठने की मुद्रा: बुरी आदतों के कारण, जैसे लंबे समय तक पैरों को क्रॉस करके बैठना, डेस्क पर काम करते समय मेज पर झुकना आदि।",
                "2. जन्मजात अलग-अलग लंबाई की टाँगें: पेल्विस का पार्श्वीय झुकाव जन्मजात अलग-अलग लंबाई की टाँगों के कारण है।",
                "3. दोनों तरफ निचले अंगों की असंतुलित मुद्रा: उदाहरण के लिए, एक पैर में सपाट पैर हैं लेकिन दूसरे में नहीं, या डिग्री समान नहीं है; घुटने का हाइपरेक्स्टेंशन दोनों तरफ मौजूद है, लेकिन अलग-अलग डिग्री तक।"
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. कशेरुका के लम्बे खंड में डिस्क प्रोट्रूजन।",
                "2. लंबे समय तक का दर्द: पेल्विस का पार्श्वीय झुकाव से टाँगों और कमर में दर्द हो सकता है, साथ ही गर्दन और कंधे में भी।",
                "3. अलग-अलग लंबाई की टाँगें।",
            ],
        }
    },
    {
        name: "O में क 모양 की टाँगें",
        key: "oleg",
        definition: {
            name: "परिभाषा",
            list: ["मानव शरीर एक सामान्य मुद्रा में खड़ा होता है। जब पैर एक साथ होते हैं, तो भीतरी टखने एक-दूसरे के करीब हो सकते हैं, लेकिन घुटनों के अंदरूनी हिस्से एक-दूसरे के करीब नहीं हो सकते हैं, या यहां तक ​​कि एक बड़ा अंतर भी होता है, और पैर \"O\" आकार दिखाते हैं। इस प्रकार का पैर का आकार दैनिक आसन की आदतों से संबंधित है, और O आकार के पैर बच्चों में भी रिकेट्स से जुड़े हो सकते हैं।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. आदतन ख़राब मुद्राएँ जैसे: पीछे की ओर पेल्विक झुकाव और पैर उलटने की प्रवृत्ति।",
                "2. मांसपेशियों की शक्ति का असंतुलन जैसे: हिप के बाहरी घुमने वाले मांसपेशियां बहुत तनी हुई।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. मेडियल मेनिस्कस क्षति: O में क 모양 की टाँगें निचले अंगों की शक्ति रेखा में बदलाव लाती हैं। घुटने के अंदरी अंतराल सामान्य भार की तुलना में अधिक दबाव सहन करता है। यह घुटने के मेडियल मेनिस्कस को क्षति पहुंचा सकता है।",
                "2. आर्थराइटिस: गंभीर मामले (O में क 모양 की टाँगें) अंततः घुटने के कंकाली आर्थराइटिस और जोड़ के बाहरी अंतराल में जोड़ के पुराने होने को ले जा सकते हैं। गंभीर मामलों में, कृत्रिम जोड़ प्रतिस्थापन सर्जरी की आवश्यकता हो सकती है।",
            ],
        }
    },
    {
        name: "X में क 모양 की टाँगें",
        key: "xleg",
        definition: {
            name: "परिभाषा",
            list: "जब एक व्यक्ति सामान्य मुद्रा में खड़ा होता है और टाँगें मिली होती हैं, तो अंदरी घुटने एक दूसरे के करीब हो सकते हैं, लेकिन टखनों का अंदरी भाग करीब नहीं हो सकता और यहां तक कि बहुत बड़ी दरार हो सकती है। टाँगों के बीच का रूप \"X\" के समान है। इस तरह के टाँगों का रूप दैनिक मुद्रा की आदतों और मांसपेशियों के असंतुलन से संबंधित है।",
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. आदतनिरूपित खराब मुद्राएँ जैसे: पेल्विस का आगे झुकाव, पैर के बाहर की ओर झुकने की प्रवृत्ति।",
                "2. मांसपेशियों का असंतुलन जैसे: हिप के अंदरी घुमने वाले मांसपेशियां बहुत कसी हुई।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. लेटरल मेनिस्कस क्षति: X में क 모양 की टाँगें निचले अंगों की शक्ति रेखा में बदलाव लाती हैं। घुटने के बाहरी अंतराल सामान्य भार की तुलना में अधिक दबाव सहन करता है। यह घुटने के लेटरल मेनिस्कस को क्षति पहुंचा सकता है।",
                "2. आर्थराइटिस: गंभीर मामले (X में क मोड़ की टाँगें) अंततः घुटने के कंकाली आर्थराइटिस और जोड़ के बाहरी अंतराल में जोड़ के पुराने होने को ले जा सकते हैं। गंभीर मामलों में, कृत्रिम जोड़ प्रतिस्थापन सर्जरी की आवश्यकता हो सकती है।",
            ],
        }
    },
    {
        name: "घुटने का अति विस्तृतन",
        key: "kneehyperextension",
        definition: {
            name: "परिभाषा",
            list: ["घुटने का अति विस्तृतन, जिसे 'घुटने का विपरीत चाप' भी कहा जाता है। मानव शरीर के पार्श्व से देखने पर, देखा जा सकता है कि टाँग पीछे की ओर मुड़ी हुई है, घुटने अंदर की ओर खोखला है और टखना मcompared to जांघ के मुकाबले अति आगे की ओर बढ़ी हुई है। यह प्रकार का मुद्रा बैलेट नर्तकियों और जांघ की मांसपेशियों में कमजोरी वाले लोगों में आम है।"],
        },
        triggerreason: {
            name: "कारण",
            list: [
                "1. गलत बल लगाने की मुद्रा: खड़े होने पर मुख्य भार पैर के आगे के हिस्से पर पड़ता है।",
                "2. पाद की फासिया में तनाव: लंबे समय तक हाई हील्स पहनने से हो सकता है।",
                "3. घुटने के चारों ओर मांसपेशियों की कमजोरी। जांघ के आगे और पीछे की मांसपेशियों में शक्ति की कमी।",
            ]
        },
        danger: {
            name: "खतरे",
            list: [
                "1. घुटने का विकृति: लंबे समय तक घुटने का अति विस्तृतन कर सकता है कि कंकाली जोड़ के पुराने होने की दर में स्पष्ट वृद्धि हो और घुटने के अत्यधिक खराबने को ले जा सके, जिससे जोड़ का विकृति हो सकती है।",
                "2. सम्पूर्ण संतुलन को क्षति: हिप, घुटने और टखने के तीनों जोड़ों के बीच बहुत बड़ी स्थिति और कार्यात्मक संबंध है। घुटने की स्थिति का बदलना इसके नीचे के टखने की स्थिति और इसके ऊपर के हिप और पेल्विस की स्थिति को प्रभावित करेगा, धीरे-धीरे शरीर के सम्पूर्ण संतुलन को क्षति पहुंचा करेगा। लंबे समय में, यह विभिन्न प्रकार के दर्द को जन्म दे सकता है।",
            ],
        }
    },
]